module.exports = __webpack_public_path__ + "img/goal.c446f973.svg";